export default function () {
  if (this.$route.params.additionalInfo) {

    this.$nextTick(() => {
      const element = document.getElementById('medicalObservationsForm');
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    });
  }
}
